import { render, staticRenderFns } from "./ProjectSettingsGeneral.vue?vue&type=template&id=173d137a&scoped=true"
import script from "./ProjectSettingsGeneral.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsGeneral.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsGeneral.vue?vue&type=style&index=0&id=173d137a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173d137a",
  null
  
)

export default component.exports